var PageId = /* @__PURE__ */ ((PageId2) => {
  PageId2["CorePDP"] = "CorePdp";
  PageId2["LatPDP"] = "LatPdp";
  PageId2["PDP"] = "PDP";
  PageId2["Gallery"] = "Gallery";
  PageId2["ChecksQuickView"] = "QuickViewAtc";
  PageId2["RecommendationLane"] = "RecommendationLane";
  PageId2["RecommendationLaneWithQuantity"] = "RecommendationLaneWithQuantity";
  PageId2["PDC"] = "PDC";
  PageId2["QuickEditor"] = "QuickEditor";
  PageId2["Cart"] = "Cart";
  PageId2["PpagProductTile"] = "PpagProductTile";
  PageId2["Category"] = "Category";
  PageId2["Checkout"] = "Checkout";
  PageId2["OrderConfirmation"] = "OrderConfirmation";
  PageId2["HomePage"] = "HomePage";
  PageId2["SearchPages"] = "SearchPages";
  PageId2["SearchDesignTiles"] = "SearchDesignTiles";
  PageId2["Studio"] = "Studio";
  PageId2["QuantitySelectionPage"] = "QuantitySelectionPage";
  PageId2["UploadFlowDialogComponent"] = "UploadFlowDialogComponent";
  PageId2["Discovery"] = "Discovery";
  PageId2["PLP"] = "PLP";
  PageId2["GalleryQuickView"] = "GalleryQuickView";
  PageId2["Favorites"] = "Favorites";
  PageId2["LaunchMyBusiness"] = "LaunchMyBusiness";
  PageId2["TeamDetailsPage"] = "TeamDetailsPage";
  PageId2["QuickProductFlowFlyout"] = "QuickProductFlowFlyout";
  PageId2["FavoritesTemplateSection"] = "FavoritesTemplateSection";
  return PageId2;
})(PageId || {});

export { PageId };
//# sourceMappingURL=src-types-pageId.js.map
